/** Shows the result of issuing an invite: email delivery state, Microsoft
 *  directory provisioning state, plus the one-time URL(s). */
export function describeDelivery(delivery, email) {
  if (delivery === 'sent') return `Invitation email sent to ${email}.`;
  if (delivery === 'failed') {
    return `The invitation email to ${email} could not be sent. Share the link below instead.`;
  }
  if (delivery === 'not_configured') {
    return 'Email delivery is not configured on this server. Share the link below with the person.';
  }
  return '';
}

export function describeDirectory(status, email) {
  if (status === 'member') return `${email} already has a Microsoft account in the Intain directory.`;
  if (status === 'guest') return `${email} is already a guest in the Intain directory.`;
  if (status === 'invited') {
    return `${email} was invited to the Intain directory as a guest. They must accept the Microsoft invitation once before "Sign in with Microsoft" works.`;
  }
  if (status === 'guest_pending') {
    return `${email} had a pending Microsoft guest invitation; a fresh one was issued.`;
  }
  if (status === 'failed') {
    return `Microsoft directory provisioning failed for ${email}; they can still accept the eVault invitation and sign in with email and password.`;
  }
  if (status === 'not_configured') {
    return 'Microsoft directory provisioning is not configured on this server; Sign in with Microsoft only works for existing directory accounts.';
  }
  return '';
}

export function InviteDelivery({ result }) {
  if (!result) return null;
  const summary = describeDelivery(result.email_delivery, result.email);
  const directory = describeDirectory(result.directory_invite, result.email);
  const tone =
    result.email_delivery === 'sent'
      ? 'border-emerald-200 bg-emerald-50 text-emerald-900'
      : 'border-amber-200 bg-amber-50 text-amber-900';
  return (
    <div className={`space-y-1 rounded-2xl border px-4 py-3 text-sm ${tone}`} role="status">
      {summary ? <p>{summary}</p> : null}
      {result.invite_url ? (
        <p className="break-all">
          <span className="font-medium">Invite link (shown once):</span> {result.invite_url}
        </p>
      ) : null}
      {directory ? <p>{directory}</p> : null}
      {result.microsoft_redeem_url ? (
        <p className="break-all">
          <span className="font-medium">Microsoft invitation link:</span>{' '}
          {result.microsoft_redeem_url}
        </p>
      ) : null}
    </div>
  );
}
